import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@piplapps/pipl-ui';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import { UsersActions } from '../../../Redux/modules/users/actions';
import styles from './UsersFooter.module.less';
import AppConfig from '../../../Config/AppConfig';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const UsersFooter = (props) => {
  return AppConfig.AUDIT_LOG_ENABLED && !props.isTrial ? (
    <div className={styles.textWrapper}>
      <div className={styles.buttonWrapper}>
        <AnalyticsHandler eventName={AnalyticsEventNames.EXPORT_AUDIT_LOGS}>
          <Button
            isLoading={props.exportAuditIsLoading}
            loadingText={gettext('Generating...')}
            id="audit-export-button"
            buttonClass="label-blue"
            text={gettext('Download an audit log')}
            onClick={() => props.exportAudit()}
          />
        </AnalyticsHandler>
      </div>
    </div>
  ) : null;
};

UsersFooter.propTypes = {
  exportAuditIsLoading: PropTypes.bool,
  exportAudit: PropTypes.func,
  isTrial: PropTypes.bool,
  usersData: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    exportAuditIsLoading: UsersSelectors.exportAuditIsLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  exportAudit: UsersActions.exportAudit,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersFooter);
